export const ADD_CONSTRAINT = "ADD_CONSTRAINT";
export const DELETE_CONSTRAINT = "DELETE_CONSTRAINT";
export const EDIT_CONSTRAINT = "EDIT_CONSTRAINT";
export const RESET_DEFAULT_CONSTRAINT = "RESET_DEFAULT_CONSTRAINT";

export const EDIT_BOUNDS_CONSTRAINTS = "EDIT_BOUNDS_CONSTRAINTS";
export const EDIT_BOUNDS_ASSUMPTIONS = "EDIT_BOUNDS_ASSUMPTIONS";
export const EDIT_BOUNDS_WEIGHTAGE_FACTORS = "EDIT_BOUNDS_WEIGHTAGE_FACTORS";
export const EDIT_BOUNDS_CONTROLLERS = "EDIT_BOUNDS_CONTROLLERS";
export const EDIT_BOUNDS_STEPS = "EDIT_BOUNDS_STEPS";
export const RESET_DEFAULT_BOUNDS = "RESET_DEFAULT_BOUNDS";

export const ADD_QTY = "ADD_QTY";
export const DELETE_QTY = "DELETE_QTY";
export const EDIT_QTY = "EDIT_QTY";

export const ADD_FILE = "ADD_FILE";
export const DELETE_FILE = "DELETE_FILE";
export const EDIT_FILE = "EDIT_FILE";

export const RESPONSE_LOADING = "RESPONSE_LOADING";
export const RESPONSE_SUCCESS = "RESPONSE_SUCCESS";
export const RESPONSE_FAILURE = "RESPONSE_FAILURE";

// export const GET_LATEST_BURDEN_LOADING = "GET_LATEST_BURDEN_LOADING";
// export const GET_LATEST_BURDEN_SUCCESS = "GET_LATEST_BURDEN_SUCCESS";
// export const GET_LATEST_BURDEN_FAILURE = "GET_LATEST_BURDEN_FAILURE";

export const GET_HISTORY_LOADING = "GET_HISTORY_LOADING";
export const GET_HISTORY_SUCCESS = "GET_HISTORY_SUCCESS";
export const GET_HISTORY_FAILURE = "GET_HISTORY_FAILURE";

export const RESET_ERROR_LOADING_STATUS = "RESET_ERROR_LOADING_STATUS";

export const EDIT_INPUT_ORE_MATERIAL_SUM = "EDIT_INPUT_ORE_MATERIAL_SUM";

export const GET_DEVIATION_LOADING = "GET_DEVIATION_LOADING";
export const GET_DEVIATION_SUCCESS = "GET_DEVIATION_SUCCESS";
export const GET_DEVIATION_FAILURE = "GET_DEVIATION_FAILURE";

export const CREATE_DEVIATION_LOADING = "CREATE_DEVIATION_LOADING";
export const CREATE_DEVIATION_SUCCESS = "CREATE_DEVIATION_SUCCESS";
export const CREATE_DEVIATION_FAILURE = "CREATE_DEVIATION_FAILURE";

export const GET_CONSTRAINTS_LOADING = "GET_CONSTRAINTS_LOADING";
export const GET_CONSTRAINTS_SUCCESS = "GET_CONSTRAINTS_SUCCESS";
export const GET_CONSTRAINTS_FAILURE = "GET_CONSTRAINTS_FAILURE";

export const ERP_FILE_UPLOAD = "ERP_FILE_UPLOAD";

export const ERP_CONVERT_LOADING = "ERP_CONVERT_LOADING";
export const ERP_CONVERT_SUCCESS = "ERP_CONVERT_SUCCESS";
export const ERP_CONVERT_FAILURE = "ERP_CONVERT_FAILURE";

export const TRANSFORM_CONTROLLERS_LOADING = "TRANSFORM_CONTROLLERS_LOADING";
export const TRANSFORM_CONTROLLERS_SUCCESS = "TRANSFORM_CONTROLLERS_SUCCESS";
export const TRANSFORM_CONTROLLERS_FAILURE = "TRANSFORM_CONTROLLERS_FAILURE";

export const UPDATE_BIN_STATUS_DATA = "UPDATE_BIN_STATUS_DATA";
export const SAVE_JSON_DATA = "SAVE_JSON_DATA";
export const UPDATE_BIN_STATUS = "UPDATE_BIN_STATUS";
export const UPDATE_BIN_STATUS_ERROR = "UPDATE_BIN_STATUS_ERROR";
export const UPDATE_POST_DATA_OBJ = "UPDATE_POST_DATA_OBJ";
